import { Component, inject, OnInit, signal } from '@angular/core';
import { AppInfoApiService } from '@core/services/app-info-api.service';
import { ToastService } from '@core/services/toast.service';

const UNKNOWN_VERSION = 'unknown';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.html',
  styles: ``,
})
export class Footer implements OnInit {
  private readonly appInfoApiService = inject(AppInfoApiService);
  private readonly toastService = inject(ToastService);

  readonly currentYear = new Date().getFullYear();

  readonly webAppVersion = signal(UNKNOWN_VERSION);
  readonly apiVersion = signal(UNKNOWN_VERSION);

  private webAppReleaseNotesUrl: string | null = null;
  private apiReleaseNotesUrl: string | null = null;

  ngOnInit(): void {
    this.appInfoApiService.getVersion().subscribe({
      next: (version) => {
        this.webAppVersion.set(version.webAppVersion || UNKNOWN_VERSION);
        this.apiVersion.set(version.apiVersion || UNKNOWN_VERSION);
        this.webAppReleaseNotesUrl = version.webAppReleaseNotesUrl || null;
        this.apiReleaseNotesUrl = version.apiReleaseNotesUrl || null;
      },
      error: () => {
        this.webAppVersion.set(UNKNOWN_VERSION);
        this.apiVersion.set(UNKNOWN_VERSION);
        this.webAppReleaseNotesUrl = null;
        this.apiReleaseNotesUrl = null;
      },
    });
  }

  openWebAppReleaseNotes(): void {
    this.openReleaseNotes(this.webAppReleaseNotesUrl);
  }

  openApiReleaseNotes(): void {
    this.openReleaseNotes(this.apiReleaseNotesUrl);
  }

  private openReleaseNotes(url: string | null): void {
    if (!url) {
      this.toastService.info('Release notes unavailable');
      return;
    }

    window.open(url, '_blank', 'noopener');
  }
}
